<template>
<DashBoardLayout :isSearch=true :showNavbar="navBarValue" v-on:searchText="getSearchText($event)" > 
<div class="w100">

    <div class="w100 position-relative mt-3">
    <div class="top-links-kr">
        <button v-for="(item,index) in buttons" :key="item.text" :class="item.state" @click="buttonClick(index)">{{item.text}}</button>
    </div>
    <button  @click="openModal" style="position:absolute;top:0;right:10px;background:#ddd;padding:7px 10px;font-size:14px;border-radius:4px;">
        <v-icon right>filter_list</v-icon>&nbsp;
Filter</button>
   <Modal @modalSucess="onModalSuccess" v-model="modalOpen"></Modal>
</div>


    <Category v-on:selecetdCategory="getCategoryValue($event)" :parentCategory="selecetdCatgText"></Category>

    <Products :selecetdCatg="selecetdCatgText" :searchBrand="selectedBrands" :headingText="headingTextValue"  :searchText="searchTextValue"></Products>
 
</div>
</DashBoardLayout>
</template>

<script>
import DashBoardLayout from '../layouts/DashboardLayout.vue'
import Category from './Categories'
import globalMixins from './globalMixins'
import Products from './RecyclerView'
import Modal from "./Modal.vue"
// import {ref} from  "@vue/composition-api"
// import {ref} from 'vue'
export default {
    components: {
       Category,
        Products, DashBoardLayout,Modal
    },
    
    name: 'Home',
    mixins:[globalMixins],
    // created(){
    //     this.$emit(`update:layout`,DashBoardLayout)n
       
    // },
    data() {
        return {
            selectedBrands:[],
            modalOpen: false,
            searchTextValue:'',
            selecetdCatgText :'All',
            apiPath: '',
            selectedApiPath:'',
            queryValue: '',
            buttonClicked: true,
            navBarValue:true,
            lastScrollPosition:0,
            headingTextValue: 'Product List',
            buttons: [{
                    text: 'All Products', 
                    state: 'activeTab',
                },
                {      
                    text: 'Top 10',
                    state: 'deactiveTab',
                },
                {
                    text: 'My favorite',
                    state: 'deactiveTab',
                },
                {
                    text: 'Offers',
                    state: 'deactiveTab',
                }

            ],
        }
    },
    mounted(){
       // this.loginStatus = localStorage.getItem("loginStatus")         
        this.loadData();
        window.addEventListener('scroll', this.onScroll)
    },beforeDestroy () {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        onScroll () {
    // Get the current scroll position
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop    // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
    if (currentScrollPosition < 0) {
      return
    }    // Here we determine whether we need to show or hide the navbar
    this.navBarValue = currentScrollPosition < this.lastScrollPosition    // Set the current scroll position as the last scroll position
    this.lastScrollPosition = currentScrollPosition
  },
   loadData(){
            this.checkSession();
            this.customer_id = localStorage.customer_id;
            
            // this.selectedApiPath = this.apis.productListUrl

        },
        onModalSuccess({x,y }) {            
            this.modalOpen = x
            this.selectedBrands = y
            console.log("selected Brands- "+y)
  },
  onNavBarChange(value)
  {
    //   alert("hhh")
      this.navBarValue=value
  },
        openModal() {
            // alert("open")
            this.modalOpen = !this.modalOpen;
        },    
        getSearchText(txtSearch)
        {
            this.searchTextValue=txtSearch
        },
        getCategoryValue(selecetdCatg)
        {
            this.selecetdCatgText = selecetdCatg
        },
        buttonClick(index) {
            // this.selectedApiPath = this.buttons[index].apiLink
            // this.parameter = this.buttons[index].q
            this.headingTextValue = this.buttons[index].text
            this.activateButton(index)
            this.selecetdCatgText='All'
            // this.buttons.$set(index, "deactiveTab")

             // alert(this.selecetdCatgText)            

        },
        activateButton(index) {
            var l=this.buttons.length
            var i=0
            for (i=0;i<l;i++) {
                if (index == i) {
                    this.buttons[i].state = "activeTab"
                } else {
                   this.buttons[i].state = "deactiveTab"
                }
            }
        },

    },
    watch:{
        searchText(){
           // alert(this.searchText)
        }
    }
}
</script>

<style>
button {
    font-size: 11px;
    border-radius: 7px;
    padding: 5px 7px;
    margin: 2px;
}

.activeTab {
    background: #1976d2;
    color: #fff;
    border: 1px solid transparent;
}

.deactiveTab {
    background: #ccc;
    color: #333;
    border: 1px solid #333;
}

.card {
    background-color: tomato;
    width: 100%;
    margin: 3px;
    padding: 5px;
    height: 80px;
    font-size: 11px;
    border-radius: 10px;
    margin: 8px 2px;
}
</style>
